import { MenuItem } from '@/types/menu.types';

interface MenuButtonProps {
  menuItem: MenuItem;
  isActive: boolean;
  handleMouseDown: (idx: number) => void;
  handleMouseUp: (path: string) => void;
  handleMouseLeave: () => void;
  idx: number;
}

export const MenuButton = ({
  menuItem,
  isActive,
  handleMouseDown,
  handleMouseUp,
  handleMouseLeave,
  idx,
  totalItems,
}: MenuButtonProps & { totalItems?: number }) => {
  // Ajustar el ancho según el número total de elementos
  const getWidthClass = () => {
    if (totalItems === 1) {
      return 'w-full max-w-md'; // Una sola tarjeta: ancho completo pero con máximo
    } else if (totalItems === 2) {
      return 'w-full sm:w-1/2 max-w-md'; // Dos tarjetas: 50% cada una, más anchas
    } else if (totalItems === 3) {
      return 'w-full sm:w-1/2 md:w-1/3 max-w-sm'; // Tres tarjetas: 33% cada una
    } else {
      return 'w-full sm:w-1/2 md:w-1/3 lg:w-1/4'; // Cuatro o más: 25% cada una
    }
  };

  const highlight = !!menuItem.highlight && !isActive;

  return (
    <button
      key={menuItem.path}
      onMouseDown={() => handleMouseDown(idx)}
      onMouseUp={() => handleMouseUp(menuItem.path)}
      onMouseLeave={handleMouseLeave}
      className={`
      relative p-6 rounded-lg shadow-md
      flex flex-col items-center text-center space-y-4
      ${highlight ? 'border-2 border-brand-orange ring-2 ring-brand-orange/30' : 'border border-gray-200 hover:border-brand-orange'}
      ${getWidthClass()}
      min-h-[200px]
      ${isActive ? 'bg-brand-orange' : highlight ? 'bg-orange-50' : 'bg-white'}
      transition-all duration-75
    `}
    >
      {highlight && menuItem.highlightBadge && (
        <span className="absolute top-3 right-3 px-2 py-0.5 rounded-full text-xs font-semibold bg-brand-orange text-white">
          {menuItem.highlightBadge}
        </span>
      )}
      <span className={isActive ? 'text-white' : 'text-brand-orange'}>{menuItem.icon}</span>
      <h2 className={`text-xl font-semibold ${isActive ? 'text-white' : 'text-gray-800'}`}>
        {menuItem.title}
      </h2>
      <p className={isActive ? 'text-white' : 'text-gray-600'}>{menuItem.description}</p>
    </button>
  );
};
